import React, { memo } from 'react'
import { faXTwitter } from '@fortawesome/free-brands-svg-icons'
import { Stack } from '@mui/material'
import { Trans } from 'react-i18next'

import CustomDialog from '../shared/customDialog/CustomDialog'
import HeadingText from '../shared/text/HeadingText'
import LabelValue from '../shared/text/LabelValue'
import { formatTicks } from '../../util/string.helpers'
import DefaultText from '../shared/text/DefaultText'
import { POINTS_PER_USD } from '../../constants/app'
import { floorNumber, formatEthCurrency } from '../../util/numbers.helpers'

const DepositedSuccessPopup = ({
  t,
  onSubmit,
  onClose,
  value,
  mainProfile: { ethPrice }
}) => {
  const points = formatTicks(floorNumber(ethPrice * value * POINTS_PER_USD))
  return (
    <CustomDialog
      isForm
      title={t('home.deposited-title')}
      description={t('home.deposited-desc')}
      open
      cancelProps={{ label: t('common.close'), autoWidth: true }}
      submitProps={{
        label: t('home.share-post'),
        autoWidth: true,
        icon: faXTwitter
      }}
      onClose={onClose}
      onSubmit={onSubmit}
      t={t}
      maxWidth='md'
      body={
        <Stack spacing={2}>
          <HeadingText label={formatEthCurrency(value)} isLargeFont />
          <LabelValue label={t('home.deposit-points-earned')} value={points} />
          <DefaultText
            label={
              <Trans
                i18nKey='home.deposit-points-desc'
                values={{ value: points }}
              />
            }
            noMargin
          />
        </Stack>
      }
    />
  )
}

export default memo(DepositedSuccessPopup)
